import React, { Component } from 'react';

import { withStyles } from "@material-ui/core/styles";
import { connect } from 'react-redux';
import CrudForUserClienti from './crud/Clienti/CrudForUserClienti'
import { modelProps } from '../../../model/Clienti';


import { styles } from '../../css/commonstyles'




class Clienti extends Component {

    constructor(props) {
        super(props);

    }



    render() {

        const { classes } = this.props;

        console.log(modelProps)

        return (
            <div className={classes.backgroundStylefafafa} >
                <div className={classes.spacingStyle3} >
                    <CrudForUserClienti
                        modelName="Clienti"
                        modelNameSingolare="Clienti"
                        modelProps={modelProps}
                    />
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {

    }

}

const mapDispatchToProps = (dispatch) => {

    return {


    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(Clienti));